import React from 'react';

const UltimoCambio = ({ultimocambio}) => {
    return (
        <li className="ultimo-cambio sombra">

            <div className="fecha-creacion">
                <p>{ultimocambio.fechaCreacion}</p>
            </div>
            
            <div className="contenido">
                <p className="nombre"><span>{ultimocambio.lugar}:</span> {ultimocambio.nombre}</p>
                <p className="accion"><span>Acción:</span> {ultimocambio.accion}</p>
                <p className="realizado-por"><span>Realizado por:</span> {ultimocambio.realizadaPor}</p>
            </div>

        </li>
     );
}
 
export default UltimoCambio;